export default __webpack_public_path__ + "static/media/placeholder-platinum-thumbnail.80ed0ff7.svg";